import { Component, OnInit, ViewChild } from '@angular/core';

import { AppData } from '../../services/appdata.service';
import { Global } from '../../services/global.service';
import { ValidationService } from '../../services/validation.service';
import { API } from '../../services/api.service';
import { Config } from '../../models/env-vars.model';
import { ArcAuthService } from 'src/app/services/auth.service';
import { alertService } from 'src/app/services/alert-service.service';

import * as moment from 'moment';
import * as bootstrap from 'bootstrap';
// import * as $ from 'jquery';
import {} from 'googlemaps';
import { ModalComponent } from 'src/app/components/modal/modal.component';

@Component({
  selector: 'app-project-creation',
  templateUrl: './project-creation.component.html',
  styleUrls: ['./project-creation.component.css']
})
export class ProjectCreationComponent implements OnInit
{
	config = Config;
	@ViewChild('modal') private modal!: ModalComponent;

	sign_agreement: boolean = false;
	loading: boolean = false;
	opted_for_non_leed: boolean = false;
	submit_error: boolean = false;
	searching_place: boolean = false;
	isFormSubmitted: boolean = false;

	orgNameP = '';
	orgContactNameP = '';
	orgContactEmailP = '';
	orgWebSiteP = '';
	errorOrganization = '';
	queryOrganization = '';
	all_organizations = [];
	searchingOrganization = false;
	loading_org_list = false;
	orgCategoryP = '_blank';
	orgSubCategoryP = '_blank';
	isFormSubmittedOwner = false;
	orgNamePError = false;
	orgContactNamePError = false;
	orgContactEmailPError = false;
	orgWebSitePError = false;
	orgSubCategoryPError = false;
	error_org = false;
	error_msg_org = '';
	org_query = '';
	orgContactEmailPErrorLength = false;
	orgCategoryPError = false;
	
	project_detail_nxt_btn = "Add project";
	go_to_LO_text = 'Register for LEED certification now';
	go_to_LO_flag = false;
	spaceType = [];
	ownerType = [];
	countries: any;
	states: any;
	canceler: any;
	pf_id: number = 0;

	rating_system = 
	[
		{"name":"LEED for transit", "value": this.config.config.settings.rating_systems.transit, "type":"building", "project_type": "transit"},
		{"name":"Parksmart", "value": this.config.config.settings.rating_systems.parksmart, "type":"building", "project_type": "parksmart"},    
		{"name":"None", "value":"none", "type":"building", "project_type": "building"},
		{"name":"None", "value":"none", "type":"city", "project_type": "city"},
		{"name":"None", "value":"none", "type":"community", "project_type": "community"},
	];
	regex = this.validator.regex;
	no_error = {
		'error': false,
		'help': undefined
	};
	formdata_error: any = {
		'project_type': this.no_error,
		'unitType': this.no_error,
		'country': this.no_error,
		'state': this.no_error,
		'sign_agreement': this.no_error,
		'name': this.no_error,
		'gross_area': this.no_error,
		'street': this.no_error,
		'city': this.no_error,
		'zip_code': this.no_error,
		'confidential': this.no_error,
		'test_project': this.no_error,
		"occupancy": this.no_error,

		"annual_ridership": this.no_error,
		"operating_hours": this.no_error,
		"full_time_staff": this.no_error,
		"time_spent_by_riders": this.no_error,
		"station_type": this.no_error,

		"noOfParkingSpace": this.no_error,
		"noOfParkingLevels": this.no_error,
		"year_constructed": this.no_error,
		"owner_email": this.no_error,
		"owner_name": this.no_error,
		"manageEntityCountry": this.no_error,
		"organization": this.no_error,

		"rating_system": this.no_error,
		"IsLeedRegistration": this.no_error,

		"ownerType": this.no_error,
		"spaceType": this.no_error
	};
	formdata: any = {
		'project_type': this.appData.get('project_type'),
		'unitType': null,
		'country': undefined,
		'state': undefined,
		'sign_agreement': true,
		'name': "",
		'gross_area': "",
		'street': "",
		'city': "",
		'zip_code': "",
		'confidential': false,
		'test_project': false,
		"occupancy": "",

		"annual_ridership": "",
		"operating_hours": "",
		"full_time_staff": "",
		"time_spent_by_riders": "",
		"station_type": undefined,

		"noOfParkingSpace": "",
		"noOfParkingLevels": "",
		"year_constructed": moment(new Date()).format("MMM DD, YYYY"),
		"owner_email": "",
		"owner_name": "",
		"manageEntityCountry": undefined,
		"organization": "",

		"rating_system": "",
		"IsLeedRegistration": 'null'
	};

	mode = 'project_creation';
	title = "Enter Project Details";
	mapAddress = '';
	places: any = [];
	project: any = {};
	go_back: string = 'project_creation';
	picker_loaded: boolean = false;

	map_styles: any = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#7c93a3"},{"lightness":"-10"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#a0a4a5"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#62838e"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#dde3e3"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#3f4a51"},{"weight":"0.30"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.place_of_worship","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"},{"visibility":"on"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#bbcacf"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"lightness":"0"},{"color":"#bbcacf"},{"weight":"0.50"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#a9b4b8"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"invert_lightness":true},{"saturation":"-7"},{"lightness":"3"},{"gamma":"1.80"},{"weight":"0.01"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#a3c7df"}]}];
	map: any;
    marker: any;
    maintenance_timeout: any;
	address: any = "2101 L st NW, DC, 20037";

	constructor(
		public appData: AppData,
		public global: Global,
		private validator: ValidationService,
		private api: API,
		private auth: ArcAuthService,
		private alertService: alertService
	)
	{
	}

	initialize() 
    {
        var latlng = new google.maps.LatLng(38.9041545, -77.0492025);
        this.map = new google.maps.Map(<any>document.getElementById('map-canvas'),
        {
            center: latlng,
            scrollwheel: false,
            zoom: 8
        });
        
        this.marker = new google.maps.Marker(
        {
            position: this.map.getCenter(),
            map: this.map,
            draggable: true,
            title: "Drag me!"
        });
        (<any>top).geoLocLat = this.map.getCenter().lat().toFixed((<any>top).geoPointsDecimal);
        (<any>top).geoLocLng = this.map.getCenter().lng().toFixed((<any>top).geoPointsDecimal);
        google.maps.event.addListener(this.marker, 'dragend', (event: any) =>
        {
            if(this.map.getZoom() < 16)
            {
                this.map.setZoom(16);
            }
            this.map.panTo(event.latLng);
            (<any>top).geoLocLat = event.latLng.lat().toFixed((<any>top).geoPointsDecimal);
            (<any>top).geoLocLng = event.latLng.lng().toFixed((<any>top).geoPointsDecimal);
        });
        google.maps.event.addListener(this.map, 'dragend', (event: any) =>
        {
            this.updateMarkerPoistion(this.map.getCenter());
        });
        this.showAddress(this.address);
    }
    
    updateMarkerPoistion(latLng: any)
    {
        this.marker.setPosition(latLng);
        (<any>top).geoLocLat = latLng.lat().toFixed((<any>top).geoPointsDecimal);
        (<any>top).geoLocLng = latLng.lng().toFixed((<any>top).geoPointsDecimal);
    }

    showAddress(address: any)
    {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode(
        {
            'address': address
        }, (results, status) =>
        {
            if(status == google.maps.GeocoderStatus.OK)
            {
                this.map.setCenter(results[0].geometry.location);
                if(this.map.getZoom() < 16)
                {
                    this.map.setZoom(16);
                }
                this.updateMarkerPoistion(results[0].geometry.location);
            }
        });
    }

	saveLatLon()
	{
		this.formdata.geoLat = this.global.formatNumber(this.marker.position.lat(), 6);
		this.formdata.geoLang = this.global.formatNumber(this.marker.position.lng(), 6);
		$('#mapModal').modal('hide');
	};

	enableFdatePicker()
	{
		if(this.picker_loaded == false)
		{
			this.picker_loaded = true;
			(<any>$('#year_constructed')).fdatepicker(
			{
				format: 'M dd, yyyy'
			}).on('changeDate', (ev: any) =>
			{
				this.formdata.year_constructed = ev.target.value;
				this.verifyField(this.formdata.year_constructed, 'year_constructed');
			});
		}
	}

	resetOrganizationDetails()
	{
		this.orgNameP = '';
		this.orgContactNameP = '';
		this.orgContactEmailP = '';
		this.orgWebSiteP = '';
		this.errorOrganization = '';
		this.queryOrganization = '';
		this.all_organizations = [];
		this.searchingOrganization = false;
		this.loading_org_list = false;
		this.orgCategoryP = '_blank';
		this.orgSubCategoryP = '_blank';
		this.isFormSubmittedOwner = false;
		this.orgNamePError = false;
		this.orgContactNamePError = false;
		this.orgContactEmailPError = false;
		this.orgWebSitePError = false;
		this.orgSubCategoryPError = false;
		this.error_org = false;
		this.error_msg_org = '';
		this.orgContactEmailPErrorLength = false;
		this.orgCategoryPError = false;

		this.formdata.manageEntityCountry = undefined;
		this.org_query = "";
		this.formdata.organization = "";
		this.formdata_error['organization'] =
		{
			'error': false,
			'help': undefined
		};
		$('.ofac_invalid_modal').modal('hide');
	}

	getDataFromModal(event: any)
	{
		this.formdata.organization = event.formdata;
		this.modal.close();
	}

	createOrganization()
	{
		this.loading = true;
		this.isFormSubmittedOwner = true;
		if(this.isFormSubmittedOwner && (this.orgCategoryP == '_blank' || this.orgCategoryP.length == 0))
		{
			this.orgCategoryPError = true;
		}
		else
		{
			this.orgCategoryPError = false;
		}
		if(this.isFormSubmittedOwner && (this.orgNameP == undefined || this.orgNameP.length == 0))
		{
			this.orgNamePError = true;
		}
		else
		{
			this.orgNamePError = false;
		}
		if(this.isFormSubmittedOwner && (this.regex.email.test(this.orgContactEmailP) == false))
		{
			this.orgContactEmailPError = true;
		}
		else
		{
			this.orgContactEmailPError = false;
		}
		if(this.isFormSubmittedOwner && (this.orgContactNameP == undefined || this.orgContactNameP.length == 0))
		{
			this.orgContactNamePError = true;
		}
		else
		{
			this.orgContactNamePError = false;
		}
		if(this.isFormSubmittedOwner && (this.orgCategoryPError || this.orgSubCategoryP == '_blank' || this.orgSubCategoryP.length == 0))
		{
			this.orgSubCategoryPError = true;
		}
		else
		{
			this.orgSubCategoryPError = false;
		}
		
		if(this.isFormSubmittedOwner && (this.orgWebSiteP.length > 0) && (this.regex.weburl.test(this.orgWebSiteP) == false))
		{
			this.orgWebSitePError = true;
		}
		else
		{
			this.orgWebSitePError = false;
		}
		
		if(this.orgNamePError == true || this.orgSubCategoryPError == true || this.orgContactEmailPError == true || this.orgContactNamePError == true || this.orgContactEmailPErrorLength == true || this.orgWebSitePError == true || this.orgCategoryPError)
		{
			this.loading = false;
			return 
		}
		
		var postData = 
		{
			orgName:  this.orgNameP, 
			orgContactName:  this.orgContactNameP, 
			orgContactEmail: this.orgContactEmailP,
			orgWebSite: this.orgWebSiteP,
			orgCategory: this.orgCategoryP,
			orgSubCategory: this.orgSubCategoryP
		};
		
		this.api.post(
			'/assets/searchowner/',
			postData
		).subscribe(data =>
		{
			this.isFormSubmittedOwner = false;
			this.loading = false;
			this.formdata_error['organization'] = {
				'error': false,
				'help': ''
			};
			if(data['record_duplicate'] != undefined)
			{
				this.error_org = true;
				this.error_msg_org = data['record_duplicate'];
				return
			}
			$('#payment_owner_modal').modal('hide'); 
			this.error_org = false;
			this.error_msg_org = '';
			this.formdata.organization = this.orgNameP;
			this.org_query = this.orgNameP;
		}, error =>
		{
			this.loading = false;
			if(error['record_duplicate'] != undefined)
			{
				this.error_org = true;
				this.error_msg_org = error['record_duplicate'];
				return
			}
		});
	}

	openModal()
	{
		// $('#payment_owner_modal').modal('show');  
		// this.resetOrganizationDetails();
		this.modal.open();
	}

	closeModal()
	{
		this.modal.close();
	}

	showDropdown()
	{
		$('.dropdown-menu.address').slideDown(200);
	};

	hideDropdown()
	{
		$('.dropdown-menu.address').slideUp(200);
	};

	checkDropdown()
	{
		if(this.places.length > 0)
		{
			this.showDropdown();
		}
		else
		{
			this.hideDropdown();
		}
	};

	selectPlace(place: any)
	{
		this.hideDropdown();
		let postal_code, state, country, city, state_long_name;
		for(let i = 0; i < place.address_components.length; i++)
		{
			let comp = place.address_components[i];
			if(comp.types.indexOf("postal_code") != -1)
			{
				postal_code = comp.short_name;
			}
			else if(comp.types.indexOf("administrative_area_level_1") != -1)
			{
				state = comp.short_name;
				state_long_name = comp.long_name;
			}
			else if(comp.types.indexOf("locality") != -1)
			{
				city = comp.long_name;
			}
			else if(comp.types.indexOf("country") != -1)
			{
				country = comp.short_name;
			}
		}
		if(city == undefined)
		{
			city = state_long_name;
		}
		this.formdata.street = place.name
		this.formdata.city = city;
		this.formdata.zip_code = postal_code;
		this.formdata.country = country;
		this.updateCountry(country);
		let found = false;
		for(let i = 0; i < this.states.length; i++)
		{
			if(state_long_name == this.states[i].name)
			{
				this.formdata.state = this.states[i].code.substr(0, 2);
				found = true;
				break;
			}
		}
		if(!found)
		{
			this.formdata.state = this.states[0].code.substr(0, 2);
		}
		this.getGeocode();
		this.verifyField(this.formdata.state, 'state');
		this.verifyField(this.formdata.street, 'street');
		this.verifyField(this.formdata.city, 'city');
		this.verifyField(this.formdata.zip_code, 'zip_code');
	};

	getPlace(address: string)
	{
		if(this.canceler)
		{
			this.searching_place = false;
			this.canceler.unsubscribe();
		}
		this.verifyField(this.formdata.street, 'street');
		this.searching_place = true;
		this.canceler = this.api.get(
			'/address/predictions/' + "?address=" + address
		).subscribe(data =>
		{
			this.places = data;
			this.searching_place = false;
			this.checkDropdown();
		});
	}

	ngOnInit(): void
	{
		$('body').click(function(e)
        {
            if(!$(e.target).hasClass('address_dropdown'))
            {
                $('.dropdown-menu.address').slideUp(200);
            }
        });

		this.api.getAsset(
			'../../assets/json/spaceTypes.json'
		).subscribe(data => 
		{
			this.spaceType = data;
		});

		this.api.getAsset(
			'../../assets/json/ownerType.json'
		).subscribe(data => 
		{
			this.ownerType = data;
		});

		if(this.config.countries == null)
		{
			this.global.fetchCountryStates().subscribe(data =>
			{
				this.config.countries = data;
				this.countries = this.global.getCountryList();
			});
		}
		else
		{
			this.countries = this.global.getCountryList()
		}

		if(this.config.state('partner_asset_id') != '' && this.config.state('partner_asset_id') != undefined)
		{
			this.formdata.name = this.config.state('name').substring(0,40);
            this.formdata.city = this.config.state('city');
            this.formdata.street = this.config.state('street');
            this.formdata.country = this.config.state('country');
            this.formdata.gross_area = this.config.state('gross_area');
            this.formdata.occupancy = this.config.state('occupancy');
            this.formdata.operating_hours = this.config.state('operating_hours');
            this.formdata.organization = this.config.state('organization');
            this.formdata.rating_system = this.config.state('rating_system');
            this.formdata.state = this.config.state('state');
            this.formdata.unitType = this.config.state('unitType');
		}

		this.formdata.project_type = this.config.state('project_type');
		if(this.config.state('pf_id') != undefined)
		{
			this.pf_id = this.config.state('pf_id');
			this.mode = 'project_add_portfolio';
			this.title = "Create a new project";
			this.formdata.project_type = 'building';
			this.go_back = 'portfolio-overview'
		}
		else
		{
			this.mode = 'project_creation';
			this.title = "Enter Project Details";
		}

		if(this.formdata.project_type == "school")
        {
            var name = this.config.state('name').substring(0,40);
            name = name.replace(/!/g, '');
            name = name.replace(/@/g, '');
            name = name.replace(/\$/g, '');
            name = name.replace(/%/g, '');
            name = name.replace(/\^/g, '');
            name = name.replace(/\*/g, '');
            name = name.replace(/\(/g, '');
            name = name.replace(/\)/g, '');
            name = name.replace(/_/g, '');
            name = name.replace(/=/g, '');
            name = name.replace(/{/g, '');
            name = name.replace(/;/g, '');
            name = name.replace(/"/g, '');
            name = name.replace(/>/g, '');
            name = name.replace(/</g, '');
            name = name.replace(/\?/g, '');
            name = name.replace(/~/g, '');
            name = name.replace(/`/g, '');
            name = name.replace(/\\/g, '');
            name = name.replace(/\|/g, '');
            name = name.replace(/}/g, '');
            this.formdata.name = name;
            this.formdata.street = this.config.state('street');
            this.formdata.city = this.config.state('city');            
            this.formdata.state = this.config.state('state');
            this.formdata.zip_code = this.config.state('zip_code');
            this.formdata.country = this.config.state('country');
			this.states = this.global.getStateList(this.config.state('country'));
            var geocoder =  new google.maps.Geocoder();
            var address = this.formdata.street + ',' + this.formdata.city + ',' + this.formdata.zip_code;
            geocoder.geocode( { 'address': address}, (results: any, status: any) =>
            {
                if (status == google.maps.GeocoderStatus.OK) 
                {
                    this.formdata.geoLat = this.global.formatNumber(results[0].geometry.location.lat(), 6);
                    this.formdata.geoLang = this.global.formatNumber(results[0].geometry.location.lng(), 6);
                }
            });

        }

		if(this.formdata.project_type == 'all')
		{
			this.formdata.project_type = 'building';
		}
		this.projectTypeChange();
		this.initialize();
	}

	updateCountry(selectedCountry: string)
	{
		this.states = this.global.getStateList(selectedCountry);
		if(this.states.length > 0)
		{
			this.formdata['state'] = this.states[0].code;
		}
		else
		{
			this.states = [
			{
				code: "",
				name: "Not Available"
			}];
			this.formdata['state'] = "";
		}
		this.getGeocode();
		this.verifyField(selectedCountry, 'country');
	};

	registerLEEDOrNonLEED(val: string)
	{
		if (val == 'yes')
		{
			this.opted_for_non_leed = false;
			this.formdata.IsLeedRegistration = 'true';
			this.verifyField(this.formdata.IsLeedRegistration, 'IsLeedRegistration');
			$('#leed_registration_block').modal('show');
			return;
		}
		else if (val == 'no')
		{
			this.formdata.IsLeedRegistration = 'false';
			this.verifyField(this.formdata.IsLeedRegistration, 'IsLeedRegistration');
		}
	}

	moveToLORegistrationPage(val: string)
	{
		if (val == "yes")
		{
			this.go_to_LO_text = 'Redirecting...';
			this.go_to_LO_flag = true;
			this.auth.getLeedOnlineToken().subscribe(data =>
			{
				let redirectPage: string;
				if(this.formdata.project_type == 'city')
				{
					redirectPage = "cities/register";
				}
				else if(this.formdata.project_type == 'community')
				{
					redirectPage = "communities/register";
				}
				else
				{
					let ratingSystem = "LEED V4.1 O+M: EB";   
					redirectPage = "projects/register?type=INP&rs=" + ratingSystem; 
				}
				redirectPage = encodeURIComponent(redirectPage);
				let loUrl = this.config.config.settings.LO_URL + "user/login?token=" + data.token + "&clientKey=" + data.clientKey + "&redirect=" + redirectPage;
				window.open(loUrl, "_target");
				this.go_to_LO_text = 'Register for LEED certification now';
				this.go_to_LO_flag = false;
			})
		}
		else
		{
			this.opted_for_non_leed = true;
			$('#leed_registration_block').modal('hide');
			this.registerLEEDOrNonLEED("no");
		}
	}

	getGeocode()
	{
		let geocoder =  new google.maps.Geocoder();
		let address = this.formdata.street + ',' + this.formdata.city + ',' + this.global.getState(this.formdata.state, this.formdata.country) + ',' + this.global.getCountry(this.formdata.country) + ',' + this.formdata.zip_code;
		geocoder.geocode( { 'address': address}, (results, status) =>
		{
			if (status == google.maps.GeocoderStatus.OK) 
			{
				this.formdata.geoLat = this.global.formatNumber(results[0].geometry.location.lat(), 6);
				this.formdata.geoLang = this.global.formatNumber(results[0].geometry.location.lng(), 6);
			}
		});
	}

	submitDetails()
	{
		try
		{
			this.getGeocode();
		}
		catch(e)
		{}
		this.isFormSubmitted = true;

		if (this.states[0].name != 'Not Available' && this.isFormSubmitted && this.formdata.state.length == 0 || this.formdata.state == null)
		{
			return;
		}

		this.project_detail_nxt_btn = "Validating info...";
		if (this.formdata.country != "SS")
		{
			let data;
			if (this.formdata.state == '' || this.formdata.state == null)
			{
				data = {
					"country": this.formdata.country,
					"zip_code": this.formdata.zip_code
				}
			}
			else
			{
				data = {
					"state": this.formdata.state,
					"country": this.formdata.country,
					"zip_code": this.formdata.zip_code
				}
			}

			this.api.post(
				'/assets/validation/', data
			).subscribe(data =>
			{
				$("#zip_code").removeClass("parsley-error")
				$("#zip_code").next('ul.parsley-errors-list').remove();

				this.createProject();
			}, error =>
			{
				try
				{
					this.formdata_error['zip_code'] = {
						'error': true,
						'help': error[0]
					};
				}
				catch(e)
				{
					this.formdata_error['zip_code'] = {
						'error': true,
						'help': "Enter a valid zip code"
					};
				}
				this.submit_error = true;
				this.project_detail_nxt_btn = "Add project";
				this.loading = false;
			});
		}
		else
		{
			this.createProject();
		}
	}

	createProject()
	{
		var payload = this.formdata;
		var url = '/assets/';
		
		if (payload['project_type'] == 'school')
		{
			payload['school_id'] = this.config.state('school_id');
		}
		
		if(!(payload['project_type'] == 'school' || payload['project_type'] == 'building' || payload['project_type'] == 'parksmart' || payload['project_type'] == 'city' || payload['project_type'] == 'community'))
		{
			url = '/assets/registration/';       
		}

		this.api.post(url, payload).subscribe(data =>
		{
			this.project = data;
			if(data.project_type == 'building' || data.project_type == 'school')
			{
				if(this.mode == 'project_add_portfolio')
				{
					this.addToPortfolio();
					return;
				}
				this.global.moveToProject(data, 0, undefined);
			}
			else
			{
				this.loading = false;
				if(data.project_type == 'parksmart')
				{
					this.global.goToPayment(data);
				}
				else
				{
					this.global.moveToProject(data, 0, undefined);  
				}                   
			}
		}, error =>
		{
			this.project_detail_nxt_btn = "Add project";
			this.loading = false;
		});
	}

	addToPortfolio()
	{
		var urls = [], payload = [];
		urls.push('/portfolios/ID:'+ this.pf_id +'/assets/');

		payload.push({
			"asset_partner_id": this.project.leed_id
		});
		
		this.project_detail_nxt_btn = "Adding project to portfolio...";
		this.loading = true;

		this.api.post(
			'/portfolios/ID:'+ this.pf_id +'/assets/', payload
		).subscribe(
			data =>
			{
				this.project_detail_nxt_btn = "Add project";
				this.loading = false;
				this.global.goToApp("selected_portfolio", 
				{
					"portfolio_id": this.appData.get('portfolio_id'),
					"app_name": 'portfolio-overview'
				});
				this.alertService.alert('success', 'Project(s) added to portfolio', 5);
			},
			error =>
			{
				this.loading = false;
				this.alertService.alert('error', 'Error adding projects to portfolio', 5);
			}
		);
	}

	verifyDetails()
	{
		if(this.config.maintenance_banner)
		{
			this.global.showMaintenanceModal();
			return;
		}
		if(this.formdata.project_type != 'transit' && (this.formdata.project_type != 'city' && this.formdata.project_type != 'community'))
		{
			delete this.formdata.occupancy;

			this.formdata_error.occupancy = {"error": false, "help": ""};
		}

		if(this.formdata.project_type != 'transit')
		{
			delete this.formdata.annual_ridership;
			delete this.formdata.operating_hours;
			delete this.formdata.full_time_staff;
			delete this.formdata.time_spent_by_riders;
			delete this.formdata.station_type;

			this.formdata_error.annual_ridership = {"error": false, "help": ""};
			this.formdata_error.operating_hours = {"error": false, "help": ""};
			this.formdata_error.full_time_staff = {"error": false, "help": ""};
			this.formdata_error.time_spent_by_riders = {"error": false, "help": ""};
			this.formdata_error.station_type = {"error": false, "help": ""};
		}
		
		if(!(this.formdata.project_type == 'parksmart'))
		{
			delete this.formdata.noOfParkingSpace;
			delete this.formdata.noOfParkingLevels;
			delete this.formdata.year_constructed;

			this.formdata_error.noOfParkingSpace = {"error": false, "help": ""};
			this.formdata_error.noOfParkingLevels = {"error": false, "help": ""};
			this.formdata_error.year_constructed = {"error": false, "help": ""};
		}
		
		if(!(this.formdata.project_type == 'building' || this.formdata.project_type == 'school'))
		{
			delete this.formdata.spaceType;

			this.formdata_error.spaceType = {"error": false, "help": ""};
		}

		if(this.formdata.project_type != 'building' && this.formdata.project_type != 'city' && this.formdata.project_type != 'community') {
			delete this.formdata.IsLeedRegistration;
		}

		if(!(this.formdata.project_type == 'building' || this.formdata.project_type == 'school' || this.formdata.project_type == 'parksmart'))
		{
			delete this.formdata.ownerType;
			delete this.formdata.owner_email;
			delete this.formdata.owner_name;
			delete this.formdata.manageEntityCountry;
			delete this.formdata.organization;

			this.formdata_error.ownerType = {"error": false, "help": ""};
			this.formdata_error.owner_email = {"error": false, "help": ""};
			this.formdata_error.owner_name = {"error": false, "help": ""};
			this.formdata_error.manageEntityCountry = {"error": false, "help": ""};
			this.formdata_error.organization = {"error": false, "help": ""};
		}

		if(this.formdata.project_type == 'building' || this.formdata.project_type == 'school')
		{
			this.formdata.rating_system = "none";
		}

		if(this.formdata.project_type == 'city' || this.formdata.project_type == 'community')
		{
			if(isNaN(parseInt(this.formdata.occupancy)))
			{
				this.formdata.occupancy = null;
			}
		}
		for(let a in this.formdata)
		{
			let optional = false;
			if(a == 'occupancy' || a == 'geoLat' || a == 'geoLang')
			{
				optional = true;
			}
			this.verifyField(this.formdata[a], a, optional);
		}

		this.submit_error = false;
		for(let a in this.formdata_error)
		{
			if(this.formdata_error[a].error)
			{
				this.submit_error = true;
				return;
			}
		}

		if (this.formdata.project_type == 'building' || this.formdata.project_type == 'school')
		{
			//OFAC validation starts
			this.loading = true;
			let org_country = this.formdata.manageEntityCountry;
			let org_name = this.formdata.organization;

			let org_full_country = this.global.getCountry(org_country);
			this.validator.validateOrganization(org_name, org_full_country).subscribe(data =>
			{
				if (data.status)
				{
					if (data.is_blocked)
					{
						this.loading = false;
						$('.ofac_invalid_modal').modal('show');
					}
					else
					{
						this.submitDetails();
					}
				}
				else if("message" in data)
				{
					this.loading = false;
					this.alertService.alert('error', data.message, 10);
				}
				else
				{
					this.loading = false;
					this.alertService.alert('error', 'Could not verify Owner/Organization details', 10);
				}
			});

			//OFAC validation ends
		}
		else
		{
			this.loading = true;
			this.submitDetails();
		}
	}

	showMap()
	{
		let address = this.formdata.street + ',' + this.formdata.city + ',' + this.global.getState(this.formdata.state, this.formdata.country) + ',' + this.global.getCountry(this.formdata.country) + ',' + this.formdata.zip_code;
		this.mapAddress = address
		$('#mapModal').modal('show');
	}

	validateOrgValues(data: any, type: string)
	{
		if(type == 'orgNameP')
		{
			this.orgNameP = data;
			if(this.isFormSubmittedOwner && (this.orgNameP == undefined || this.orgNameP.length == 0))
			{
				this.orgNamePError = true;
			}
			else
			{
				this.orgNamePError = false;
			}
		}
		
		if(type == 'orgContactEmailP')
		{
			this.orgContactEmailP = data;
			if(this.isFormSubmittedOwner && (this.regex.email.test(this.orgContactEmailP) == false))
			{
				this.orgContactEmailPError = true;
			}
			else
			{
				this.orgContactEmailPError = false;
			}
		}
		
		if(type == 'orgContactNameP')
		{
			this.orgContactNameP = data;
			if(this.isFormSubmittedOwner && (this.orgContactNameP == undefined || this.orgContactNameP.length == 0))
			{
				this.orgContactNamePError = true;
			}
			else
			{
				this.orgContactNamePError = false;
			}
		}
		
		if(type == 'orgWebSiteP')
		{
			this.orgWebSiteP = data;
			if(this.isFormSubmittedOwner && (this.orgWebSiteP.length > 0) && (this.regex.weburl.test(this.orgWebSiteP) == false))
			{
				this.orgWebSitePError = true;
			}
			else
			{
				this.orgWebSitePError = false;
			}
		}
	}

	verifyField(data: any, key: string, optional?: boolean)
	{
		if(this.regex[key] == undefined)
		{
			return;
		}
		
		if(key == 'state' && this.formdata.state == undefined)
		{
			this.formdata_error[key] = {
				'error': true,
				'help': 'This field is required'
			};
			return;
		}
		else if(key == 'state')
		{
			this.formdata_error[key] = {
				'error': false,
				'help': undefined
			};
			return;
		}

		if(data == undefined || data == null || data.length == 0 || (data == 'null' && ['project_type', 'unitType', 'spaceType', 'ownerType', 'manageEntityCountry', 'country', 'station_type', 'IsLeedRegistration'].indexOf(key) != -1))
		{
			if(optional)
			{
				this.formdata_error[key] = {
					'error': false,
					'help': undefined
				};
				delete this.formdata[key];
				return;
			}
			this.formdata_error[key] = {
				'error': true,
				'help': 'This field is required'
			};
		}
		else if(this.regex[key].test(data) && key != 'organization')
		{
			this.formdata_error[key] = {
				'error': false,
				'help': undefined
			};
		}
		else if(key != 'organization')
		{
			this.formdata_error[key] = {
				'error': true,
				'help': this.regex[key + 'Msg']
			};
		}

		if(key == 'gross_area')
		{
			let max = this.global.getMax(this.formdata.unitType, this.formdata.project_type);
			if(parseFloat(data) > parseFloat(max))
			{
				this.formdata_error[key] = {
					'error': true,
					'help': 'Exceeded maximum value'
				};
			}
		}
		if(key == 'time_spent_by_riders')
		{
			let max: number = 1440;
			if(parseFloat(data) > parseFloat(String(max)))
			{
				this.formdata_error[key] = {
					'error': true,
					'help': 'Exceeded maximum value'
				};
			}
		}

		this.submit_error = false;
		for(let a in this.formdata_error)
		{
			if(this.formdata_error[a].error)
			{
				this.submit_error = true;
				break;
			}
		}
	}

	searchDisableOrganization()
	{
		this.searchingOrganization = false;
	}
	
	searchEnableOrganization()
	{
		this.searchingOrganization = true;
	}

	selectOrganization(org: string)
	{
		this.formdata_error['organization'] = {
			'error': false,
			'help': ''
		};
		this.formdata.organization = org;
		this.searchDisableOrganization();
	};

	searchOrganization(query: string)
	{
		if(this.canceler)
		{
			this.canceler.unsubscribe();
		}
		this.searchEnableOrganization();
		query = query.substr(0, 100);
		this.loading_org_list = true;
		this.canceler = this.api.get(
			'/assets/searchowner/?q=' + query
		).subscribe(data =>
		{
			this.loading_org_list = false;
			this.all_organizations = data.owner_type;
		}, error =>
		{
			this.loading_org_list = false;
		});
	}

	calculateWeeklyOccupancy(annual_ridership: number, operating_hours: number, full_time_staff: number, time_spent_by_riders: number)
	{
		let occupancy: any;
		if (annual_ridership && operating_hours && full_time_staff && time_spent_by_riders)
		{
			let daily_avg_ridership = annual_ridership / 365;
			let time_spent_by_riders_in_hours = time_spent_by_riders / 60;
			let daily_operating_hours = operating_hours / 7;

			occupancy = parseInt(String(full_time_staff)) + parseInt(String(Math.round(daily_avg_ridership * (time_spent_by_riders_in_hours / daily_operating_hours))));

			if (Number.isNaN(occupancy) || occupancy == Infinity)
			{
				$('input[name=occupancy]').removeClass('occ_valid');
				this.formdata.occupancy = "";
			}
			else
			{
				$('input[name=occupancy]').addClass('occ_valid');
				this.formdata.occupancy = occupancy;
			}
		}
		else
		{
			$('input[name=occupancy]').removeClass('occ_valid');
			this.formdata.occupancy = "";
		}
	}

	updateViewBasedOnRatingSystem(projectType: string)
	{   
		let val;
		for(let i = 0; i < this.rating_system.length; i++)
		{
			if(this.rating_system[i].project_type == projectType)
			{
				val = this.rating_system[i].value;
				break;
			}
		}
		return val;
	}

	projectTypeChange()
	{
		if(this.formdata.project_type == 'transit')
		{
			this.formdata["annual_ridership"] = "";
			this.formdata["operating_hours"] = "";
			this.formdata["full_time_staff"] = "";
			this.formdata["time_spent_by_riders"] = "";
			this.formdata["station_type"] = undefined;
		}
		else if(this.formdata.project_type == 'parksmart')
		{
			this.formdata["noOfParkingSpace"] = "";
			this.formdata["noOfParkingLevels"] = "";
			this.formdata["year_constructed"] = moment(new Date()).format("MMM DD, YYYY");
		}

		if(this.formdata.unitType == null)
		{
			this.formdata.unitType = 'IP';
			this.verifyField('IP', 'unitType');
		}
		
		this.formdata.rating_system = this.updateViewBasedOnRatingSystem(this.formdata.project_type);
		this.verifyField(this.formdata.project_type, 'project_type');
		this.appData.set('project_type', this.formdata.project_type);
	}

	resetSubCat(elem: string)
	{
		this.orgCategoryPError = false;
		this.orgCategoryP = elem;
	};

	resetSubCat2(elem: string)
	{
		this.orgSubCategoryPError = false;
		this.orgSubCategoryP = elem;
	};
}
